module.exports = __webpack_public_path__ + "img/375.5b1619b1.jpg";